import React from 'react';
import CheckBox from '../../Generic/Input/CheckBox';
import { NewProductFilterValues, BrandsFilters, HydratedFilterValue } from '../../../redux/products/types';
import { Dictionary } from '../../../../../types/globals';
import { BellaTestIds } from '../../../../common/qaIds';
import { FilterValue } from './filterValueService';
import { ListFiltersLayout, CountLabel } from './CommonFilterElements';
import { StyledFilterItemWrapper } from './StandardFilters';

interface OwnProps {
    value: FilterValue;
    filterOptions: BrandsFilters;
    name: string;
    handleValueChange: (newValue: NewProductFilterValues) => void;
}

type Props = OwnProps;

const formatAndSortBrands = (countValues: Dictionary<number>, hydratedVals: Dictionary<HydratedFilterValue>) =>
    Object.keys(countValues)
        .filter(item => hydratedVals[item])
        .map(item => {
            const hydratedValue = hydratedVals[item];
            return {
                id: item,
                count: countValues[item],
                name: hydratedValue.name,
                key: hydratedValue.url_key,
            };
        })
        .sort((a, b) => (a.name!.toLowerCase() > b.name!.toLowerCase() ? 1 : -1));

const BrandsFilter: React.SFC<Props> = ({ filterOptions, handleValueChange, name, value }) => {
    const { values, hydratedValues } = filterOptions;
    const selectedUrlKeys = Array.isArray(value) ? value : [];

    const handleCheckBoxValueChange = (newValue: string) => {
        const index = selectedUrlKeys.indexOf(newValue);
        if (index > -1) {
            selectedUrlKeys.splice(index, 1);
        } else {
            selectedUrlKeys.push(newValue);
        }

        handleValueChange({ name, value: selectedUrlKeys });
    };

    const sortedBrands = formatAndSortBrands(values, hydratedValues);

    return (
        <ListFiltersLayout>
            {sortedBrands.map(brandData => {
                return (
                    <StyledFilterItemWrapper
                        key={`brands-filter-${brandData.id}`}
                        data-testid={BellaTestIds.brandFilterItem}
                    >
                        <CheckBox
                            text={brandData.name}
                            value={brandData.key}
                            isChecked={selectedUrlKeys.includes(brandData.key)}
                            onChange={(_, urlKey) => handleCheckBoxValueChange(urlKey)}
                        />
                        <CountLabel count={brandData.count} />
                    </StyledFilterItemWrapper>
                );
            })}
        </ListFiltersLayout>
    );
};

export default BrandsFilter;
